export default {
  'nav.categories': 'Categorías',
  'nav.home': 'Inicio',
  'nav.shoppingGuide': 'Guía de compras',
  'nav.review': 'Reseña',
  'nav.shipping': 'Envío',
  'nav.safety': 'Seguridad',
  'nav.buyNow': 'Comprar ahora',
  'nav.language': 'Idioma',

  'footer.tagline': 'Un recurso independiente para encontrar productos, revisar el control de calidad y comprar de forma más inteligente.',
  'footer.disclaimer': 'Este sitio web es un recurso informativo independiente y no está afiliado, respaldado ni patrocinado por USFans ni por ningún vendedor. Verifica siempre la información antes de hacer un pedido.',
  'footer.quickLinks': 'Enlaces rápidos',
  'footer.home': 'Inicio',
  'footer.guide': 'Guía de USFans Spreadsheet',
  'footer.categories': 'Categorías',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.language': 'Idioma',

  'cta.exploreSpreadsheet': 'Explorar USFans Spreadsheet',
  'cta.buyNow': 'Comprar ahora',
  'cta.startGuide': 'Empezar con la guía para principiantes',
  'cta.browseCategories': 'Ver todas las categorías',
  'cta.readGuide': 'Leer la guía',
  'cta.readArticle': 'Leer la guía',
  'cta.continueMain': 'Ir al sitio web principal',
  'cta.readSafety': 'Leer la guía de seguridad',
  'cta.backHome': 'Volver al inicio',
};